<template>
  <!--  <v-btn-->
  <!--    text-->
  <!--    x-small-->
  <!--    color="primary"-->
  <!--    style="text-decoration: underline"-->
  <!--    @click="gotoView()"-->
  <!--  >-->
  <!--    {{ model.supportNumber || 'Будущий' }}-->
  <!--  </v-btn>-->
  <!--&lt;!&ndash;<v-icon>fa-copy</v-icon>&ndash;&gt;-->
  <span
    style="text-decoration: underline;color: #1976d2 !important;cursor: pointer"
    class="btn"
    @click="gotoView()"
  >
    {{ model.supportNumber || 'Будущий' }}
  </span>
</template>

<script>

export default {
  name: 'OfficeListItemComponent',
  props: {
    routeName: {
      type: String
    },
    model: {
      type: Object
    },
  },
  async  created () {
  },
  methods: {
    gotoView () {
      if (this.routeName && this.model && this.model.id) {
        const routeData = this.$router.resolve({ name: this.routeName, params: { id: this.model.id } })
        window.open(routeData.href, '_blank')
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  tr {
    border: 3px solid red;
  }
</style>
